import api from './api';

export const getAllBookings = async (params = {}) => {
  const response = await api.get('/bookings', { params });
  return response.data;
};

export const getBooking = async (id) => {
  const response = await api.get(`/bookings/${id}`);
  return response.data;
};

export const createBooking = async (bookingData) => {
  const response = await api.post('/bookings', bookingData);
  return response.data;
};

export const updateBooking = async (id, bookingData) => {
  const response = await api.put(`/bookings/${id}`, bookingData);
  return response.data;
};

export const deleteBooking = async (id, cancelReason) => {
  const response = await api.delete(`/bookings/${id}`, { data: { cancel_reason: cancelReason } });
  return response.data;
};

export const checkAvailability = async (roomId, startDate, endDate) => {
  const response = await api.get('/bookings/availability', {
    params: { room_id: roomId, start_date: startDate, end_date: endDate }
  });
  return response.data;
};
